import { Box } from "@chakra-ui/react";

import { useGetEventNames } from "../../api/useGetEventNames";
import MultiSelectField from "../MultiSelectInputs";

const EventNameSelect = () => {
  const { data: eventNames, isError } = useGetEventNames();

  const eventOptions = eventNames?.reduce(
    (acc: { [key: string]: string }, val) => {
      acc[val] = val;
      return acc;
    },
    {}
  );

  return (
    <Box data-testid="event-name-select" w="100%">
      <MultiSelectField
        collapseInput
        label="Event Name"
        name="eventName"
        options={eventOptions || {}}
        allowCustomInput={isError}
        testId="event-name"
      />
    </Box>
  );
};

export default EventNameSelect;
